import { c as _c } from "react/compiler-runtime";
import { Text } from "@flat-ui";
import { Box, Stack } from "@mui-wrapper";
/** Component to display general information of the projects map */
export function ProjectsMapInfoPage(t0) {
  const $ = _c(14);
  const {
    title,
    subtitle,
    source
  } = t0;
  const Icon = source;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      height: "100%",
      width: "100%",
      backgroundColor: "surfaces.secondary",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      padding: "16px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      backgroundColor: "background.paper",
      borderRadius: "50%",
      width: "80px",
      height: "80px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      height: "40px",
      width: "40px"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== Icon) {
    t4 = <Box sx={t2}><Icon aria-hidden="true" sx={t3} /></Box>;
    $[3] = Icon;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      marginTop: "16px"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== title) {
    t6 = <Text variant="heading24" sx={t5}>{title}</Text>;
    $[6] = title;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== subtitle) {
    t7 = subtitle && <Text variant="bodyL" sx={{
      marginTop: "16px",
      color: "text.secondary"
    }}>{subtitle}</Text>;
    $[8] = subtitle;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t4 || $[11] !== t6 || $[12] !== t7) {
    t8 = <Stack sx={t1}>{t4}{t6}{t7}</Stack>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}